import { ObservationsV1IssuePriorityLevel } from '@spotify/confidence-graphql';

export type IssuePriorityOption = {
  label: string;
  value: ObservationsV1IssuePriorityLevel;
};

export const ISSUE_PRIORITY_OPTIONS: readonly IssuePriorityOption[] = [
  { label: 'Critical', value: ObservationsV1IssuePriorityLevel.Critical },
  { label: 'High', value: ObservationsV1IssuePriorityLevel.High },
  { label: 'Medium', value: ObservationsV1IssuePriorityLevel.Medium },
  { label: 'Low', value: ObservationsV1IssuePriorityLevel.Low },
];

export const getIssuePriorityLabel = (
  priority: ObservationsV1IssuePriorityLevel,
): string =>
  ISSUE_PRIORITY_OPTIONS.find(option => option.value === priority)?.label ??
  priority;
